// extracted by mini-css-extract-plugin
export default {"checked":"styles_checked__Afivj","mainCheckBoxInner":"styles_mainCheckBoxInner__AtGag","checkedMain":"styles_checkedMain__yIo7e","unChecked":"styles_unChecked__03-6T"};